var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.shipcount == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("Shipping Details Not Found For This Order")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listShippingDetailsData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left ",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingcompany))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vehicle_no))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.dateFormatDetail(data.dispatcheddatetime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.dispatchedbyuser))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.dispatchedtouser))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v(_vm._s(data.shipmentstatus))])])])
  })], 2)])])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.listOrderMasterdata.status == 'cancelled' || _vm.listOrderMasterdata.status == 'created' || _vm.listOrderMasterdata.status == 'allocated' || _vm.listOrderMasterdata.status == 'picked') ? _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm.listOrderMasterdata.status == 'cancelled') ? _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v(" " + _vm._s(_vm.toUpper(_vm.listOrderMasterdata.status)))]) : _vm._e(), _vm._v(" "), (_vm.listOrderMasterdata.status != 'cancelled') ? _c('span', {
    staticClass: "badge badge-info"
  }, [_vm._v(_vm._s(_vm.toUpper(_vm.listOrderMasterdata.status)))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.listOrderMasterdata.modifyby))])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.dateFormatDetail(_vm.listOrderMasterdata.modifieddatetime)))])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table table-bordered",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [(_vm.shipmentDetailsCount == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("Picking Details Not Found For This Order")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shipmentDetailsStatus), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "badge badge-info"
    }, [_vm._v(_vm._s(data.shipmentstatus))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.lastmodifiedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.dateFormatDetail(data.lastmodifieddate)))])])
  })], 2)])])])])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Shipping Item Details")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipping Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("AWB No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipping Company")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Vehicle No. ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Handover Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Handover By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Handover To")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipment Status")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Order Status Log")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Order Status:")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Last Modified By:")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Last Modified Date:")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("OrderId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("ShippingId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("AwbNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("LastmodifiedBy")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("LastmodifiedDate")])])])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1ac7577d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac7577d","hasScoped":true}!./src/views/components/orderdetailstab/shippingdetails/shippingdetails.component.html
// module id = 1402
// module chunks = 0